import { render, staticRenderFns } from "./TheAlerts.vue?vue&type=template&id=76c8fd7b&scoped=true"
import script from "./TheAlerts.vue?vue&type=script&lang=js"
export * from "./TheAlerts.vue?vue&type=script&lang=js"
import style0 from "./TheAlerts.vue?vue&type=style&index=0&id=76c8fd7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c8fd7b",
  null
  
)

export default component.exports